
const ENTRADA = 'ENTRADA';
const SALIDA = 'SALIDA';

const PORCENTAJE = 'PORCENTAJE';
const FIJO = 'FIJO';

const FACTURA_CONTADO = 'FACTURA_CONTADO';
const FACTURA_CREDITO = 'FACTURA_CREDITO';
const FACTURAS = [ FACTURA_CONTADO, FACTURA_CREDITO ];
const COMPRA = 'COMPRA';

const REGISTERED = 'REGISTERED';
const TO_SEND = 'TO_SEND';
const WAITING_RESPONSE = 'WAITING_RESPONSE';
const TO_NOTIFY = 'TO_NOTIFY';
const FAILED = 'FAILED';
const PENDING = 'PENDING';
const IN_PROCESS = 'IN_PROCESS';
const ACCEPTED = 'ACCEPTED';
const ACCEPTED_WITH_OBSERVATIONS = 'ACCEPTED_WITH_OBSERVATIONS';
const REJECTED = 'REJECTED';
const REQUESTED = 'REQUESTED';
const FINISHED = 'FINISHED';

const ENCF_STATUS = {
  REGISTERED,
  TO_SEND,
  FAILED,
  WAITING_RESPONSE,
  TO_NOTIFY,
  FINISHED,
}

const ENCF_INTERNAL_STATUS = {
  PENDING,
  REQUESTED,
  FAILED,
  FINISHED,
}

const ENCF_LEGAL_STATUS = {
  REJECTED,
  ACCEPTED,
  ACCEPTED_WITH_OBSERVATIONS,
  IN_PROCESS,
}

const BOOTSTRAP_COLORS = {
    BLUE: "#0d6efd",
    GREEN: "#198754",
    YELLOW: "#ffc107",
    CYAN: "#0dcaf0",
    RED: "#dc3545",
    PINK: "#d63384",
    ORANGE: "#fd7e14",
    TEAL: "#20c997",
    PURPLE: "#6f42c1",
    INDIGO: "#6610f2",
    GRAY: "#6c757d",
    GRAYDARK: "#343a40",
    BLACK: "#000000",
    WHITE: "#ffffff",
    DARK: "#212529",
    PRIMARY: "#0d6efd",
    SECONDARY: "#6c757d",
    SUCCESS: "#198754",
    INFO: "#0dcaf0",
    WARNING: "#ffc107",
    DANGER: "#dc3545",
    LIGHT: "#f8f9fa",
}

const STATIC_URL = '/static/';
const MEDIA_URL = '/media/';

const IMG_ARTICULO = STATIC_URL + '/img/base/modules/articulo/articulo.svg';
const IMG_PERSON = 'https://cdn.unolet.com/img/icons/person.svg';
const IMG_COMPANY = 'https://cdn.unolet.com/img/icons/company.svg';


// -----------------------------------------------------------------------------
// TODO: Legacy code. Remove when possible.
// -----------------------------------------------------------------------------

const True = true;
const False = false;
const None = null;
const IS_PROCESS_SUBMIT = false; // Para prevenir hacer el submit más de una vez.

// -----------------------------------------------------------------------------
// End of legacy code
// -----------------------------------------------------------------------------


export default {
  ENTRADA,
  SALIDA,
  PORCENTAJE,
  FIJO,
  FACTURA_CONTADO,
  FACTURA_CREDITO,
  FACTURAS,
  COMPRA,
  FAILED,
  PENDING,
  ACCEPTED,
  REJECTED,
  REQUESTED,
  FINISHED,
  REGISTERED,
  TO_SEND,
  WAITING_RESPONSE,
  TO_NOTIFY,
  IN_PROCESS,
  ACCEPTED_WITH_OBSERVATIONS,
  ENCF_STATUS,
  ENCF_INTERNAL_STATUS,
  ENCF_LEGAL_STATUS,
  BOOTSTRAP_COLORS,

  // URLs
  STATIC_URL,
  MEDIA_URL,
  IMG_ARTICULO,
  IMG_PERSON,
  IMG_COMPANY,

  // Legacy
  True,
  False,
  None,
  IS_PROCESS_SUBMIT,
};